import React, { Component } from 'react';
import { Table, Row, Button, message, Spin, DatePicker } from 'antd';
import moment from 'moment';
import { inject, observer } from "mobx-react";
import { defaultData } from './data';
import Auth from "../../../table/Auth";
import { compute } from "./compute";
import FileSaver from "file-saver";
import TableText from "../../../table/TableText";

const { MonthPicker } = DatePicker;
const totalIndex = [];

@inject('store')
@observer
class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: moment().subtract(1, 'month').format('YYYY-MM'),
            dateData: [],
            data: [],
            loading: true,
            loadingSave: false,
            print: false,
            monthDataAll: {}
        }
    }

    componentDidMount() {
        this.getDateData(this.state.date);
    }

    computeNum = async (data) => {
        data = await compute(data);
        this.setState({ data });
    }

    onChange = (name, value, i) => {
        let data = this.state.data;
        data[i][name] = value;
        this.computeNum(data);
    }

    getDateData = (date) => {
        const dataBegin = JSON.stringify(defaultData);
        let data = JSON.parse(dataBegin);
        const year = moment(date).format('YYYY');
        const month = moment(date).format('M');

        fetch(`/getPriceRepairing?year=${year}&month=${month}`, { credentials: 'include' }).then(x => x.json()).then(x => {
            if (x.data && x.data.length > 0) {
                data = x.data;
            }
            this.setState({ loading: false });
            this.computeNum(data);

        }).catch(err => {
            this.setState({ loading: false });
            console.error(err);
        })
    }


    downloadExcel = () => {
        const tableName = `${moment(this.state.date).format('YYYY-MM')} 1.1  Price Repairing 官网比价`
        const innerHtml = `
          <caption>${tableName}</caption>
          ${document.getElementById('table').innerHTML.replace(/<table class="">/g, '<table border="1">')}
        `;

        var html = "<html><head><meta charset='utf-8' /></head><body>" + innerHtml + "</body></html>";
        var blob = new Blob([html], { type: "application/vnd.ms-excel" });
        FileSaver.saveAs(blob, `${(tableName) + (this.state.date)}.xls`);
        this.setState({ print: false });
    }


    render() {
        const data = this.state.data;

        const columns = [{
            title: '',
            dataIndex: 'name',
            key: 'name',
            align: "center",
            width: 100,
            render: (text, record, index) => {
                if (!(index % 2)) {
                    return {
                        props: { rowSpan: 2 },
                        children: <div className={`table-padding ${totalIndex.includes(index) ? 'table-color-footer' : ''} `} style={{ textAlign: "left" }}>
                            {text}
                        </div >
                    }
                }
                return {
                    props: {
                        rowSpan: 0
                    }
                }
            }
        }, {
            title: '',
            align: "center",
            width: 150,
            dataIndex: 'room_type',
            key: 'room_type',
            render: (text, record, index) => {
                const props = {
                    text,
                    index,
                    type: 'text',
                    name: "room_type",
                    onChange: this.onChange,
                    totalIndex,
                };

                return (
                    <TableText data={{ ...props }} />
                )
            }
        },
        {
            title: '2nd Day',
            align: "center",
            width: 150,
            dataIndex: 'day2',
            key: 'day2',
            render: (text, record, index) => {
                const props = {
                    text,
                    index,
                    type: 'number',
                    name: "day2",
                    onChange: this.onChange,
                    totalIndex,
                };

                return (
                    <TableText data={{ ...props }} />
                )
            }
        },
        {
            title: '3nd Day',
            align: "center",
            width: 150,
            dataIndex: 'day3',
            key: 'day3',
            render: (text, record, index) => {
                const props = {
                    text,
                    index,
                    type: 'number',
                    name: "day3",
                    onChange: this.onChange,
                    totalIndex,
                };

                return (
                    <TableText data={{ ...props }} />
                )
            }
        },
        {
            title: '4nd Day',
            align: "center",
            width: 150,
            dataIndex: 'day4',
            key: 'day4',
            render: (text, record, index) => {
                const props = {
                    text,
                    index,
                    type: 'number',
                    name: "day4",
                    onChange: this.onChange,
                    totalIndex,
                };

                return (
                    <TableText data={{ ...props }} />
                )
            }
        }, {
            title: '5nd Day',
            align: "center",
            width: 150,
            dataIndex: 'day5',
            key: 'day5',
            render: (text, record, index) => {
                const props = {
                    text,
                    index,
                    type: 'number',
                    name: "day5",
                    onChange: this.onChange,
                    totalIndex,
                };

                return (
                    <TableText data={{ ...props }} />
                )
            }
        }, {
            title: '6nd Day',
            align: "center",
            width: 150,
            dataIndex: 'day6',
            key: 'day6',
            render: (text, record, index) => {
                const title = ['Year End', `Budget`, 'Occ%'];
                const props = {
                    text,
                    index,
                    type: 'number',
                    name: "day6",
                    onChange: this.onChange,
                    totalIndex,
                };

                return (
                    <TableText data={{ ...props }} />
                )
            }
        }, {
            title: '7nd Day',
            align: "center",
            width: 150,
            dataIndex: 'day7',
            key: 'day7',
            render: (text, record, index) => {
                const props = {
                    text,
                    index,
                    type: 'number',
                    name: "day7",
                    onChange: this.onChange,
                    totalIndex,
                };

                return (
                    <TableText data={{ ...props }} />
                )
            }
        }];

        return (
            <Spin spinning={this.state.loading}>
                <div className="table7_1_1">
                    <Row className="title" id="table4_1_1"  >
                        <Row>1.1  Price Repairing 官网比价</Row>
                        <Row className="table-month">
                            <MonthPicker
                                placeholder="请选择年月"
                                monthCellContentRender={(date, local) => {
                                    return moment(date).format('M月')
                                }}
                                defaultValue={moment(this.state.date, "YYYY-MM")}
                                format="YYYY-MM"
                                onChange={(date, str) => {
                                    this.setState({
                                        date: str,
                                        data: [],
                                        loading: true
                                    });
                                    this.getDateData(str)
                                }}
                            />
                        </Row>
                        <Table
                            columns={columns}
                            dataSource={data}
                            size="middle"
                            id="table"
                            bordered
                            pagination={false}
                            className="content"
                            rowKey={(record, index) => index}
                        />
                    </Row>
                    <Auth loading={this.state.loading} auth="edit_4_1">
                        <Row className="table-footer-btn">
                            <Button
                                type="primary"
                                onClick={() => {
                                    this.setState({ print: true }, () => {
                                        this.downloadExcel();
                                    });
                                }}
                                loading={this.state.print}
                            >导出Excel</Button>
                        </Row>
                    </Auth>


                </div>
            </Spin >
        );
    }
}

export default index;



// WEBPACK FOOTER //
// ./src/components/otherHeadquartersForms/price/1.1/index.js